// セッション関連
import commonClass from "./commonClass";

export default class sessionClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    // テンプレート
    this._$tmplTimeTable;
    this._$tmplTitle;
    this._$tmplInstructor;
    // タブ関連クラス名
    this._tabPrt = '.js-ssntab_prt';
    this._tabTrg = '.js-ssntab_trg';
    this._tabAdd = '.js-ssntab_add';
    this._tabAddTrg = '.js-ssntab_addtrg';
    this._tabTrgCtnr = '.js-ssntab_trgctnr';
    this._tabTgt = '.js-ssntab_tgt';
    this._tabTgtCtnr = '.js-ssntab_tgtctnr';
    this._tabDel = '.js-ssntab_del';
    this._tabName = '.js-ssntab_name';
    // タブのデフォルト名
    this._tabNameDefault = 'セッションID';

    // セクション操作関連クラス名
    this._secTtl = '.js-ssnsec_ttl';
    this._secTimeTable = '.js-ssnsec_timetable';
    this._secDelTimeTable = '.js-ssnsec_deltimetable';
    this._secAddTtl = '.js-ssnsec_addttl';
    this._secDelTtl = '.js-ssnsec_delttl';
    this._secAddTimeTable = '.js-ssnsec_addtimetable';
    this._secAddInstructor = '.js-ssnsec_addInstructor';
    this._secAddInstructorArea = '.js-ssnsec_addInstructorArea';
    this._secDelTgt = '.js-ssnsec_delTgt';
    this._secDelTrg = '.js-ssnsec_delTrg';
    this._$secAddArea = $('.js-ssnsec_addarea');
  }

  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._getTemplate();
    cls._initTab();
    cls._initSection();

    // チェックボックスON/OFFでブロック全体をDisable（削除）にする
    // ※外部呼び出し処理に伴いコメントアウト！
    // 代わりにセッションページの画面ロード時に呼ぶ！！
    // APP.BlockDisable._setSelector(cls._secDelTrg, cls._secDelTgt);
  }

  // テンプレート取得
  _getTemplate() {
    var cls = this;

    var $tmplTimeTable = $('.js-ssntmpl-timetable');
    cls._$tmplTimeTable = $tmplTimeTable.clone().removeClass('js-ssntmpl-timetable');
    $tmplTimeTable.remove();

    var $tmplTitle = $('.js-ssntmpl-ttl');
    cls._$tmplTitle = $tmplTitle.clone().removeClass('js-ssntmpl-ttl');
    $tmplTitle.remove();

    var $tmplInstructor = $('.js-ssntmpl-instructor');
    cls._$tmplInstructor = $tmplInstructor.clone().removeClass('js-ssntmpl-instructor');
    $tmplInstructor.remove();
  }

  _initTab() {
    var cls = this;

    // タブ切り替え
    $(document).on('click', cls._tabTrg, function() {
      var $this = $(this);

      if ($this.hasClass('is-current')) {
        return false;
      }

      var tabParts = cls._getTabParts($this);
      var idx = tabParts.$trg.index($this);

      tabParts.$trg.removeClass('is-current');
      tabParts.$tgt.removeClass('is-show');

      tabParts.$trg.eq(idx).addClass('is-current');
      tabParts.$tgt.eq(idx).addClass('is-show');

      return false;
    });

    // タブ追加
    $(document).on('click', cls._tabAddTrg, function() {
      var $this = $(this);
      var tabParts = cls._getTabParts($this);

      var $addTab = cls._$tmplTimeTable.find(cls._tabTrg).clone();
      var $addCont = cls._$tmplTimeTable.find(cls._tabTgt).clone();

      tabParts.$trg.removeClass('is-current');
      tabParts.$tgt.removeClass('is-show');

      $this.parent(cls._tabAdd).before($addTab);
      tabParts.$tgtCtnr.append($addCont);

      return false;
    });

    // タブ削除
    $(document).on('change', cls._tabDel, function() {
      var $this = $(this);
      var tabParts = cls._getTabParts($this);

      // カレント状態のタブとタブコンテンツを取得
      var $currentTrg = tabParts.$trg.filter(function(index, el){
        return $(el).hasClass('is-current');
      });

      if ($this.prop('checked')) {
        $currentTrg.addClass('is-del');
      } else {
        $currentTrg.removeClass('is-del');
      }

      return false;
    });

    // タブ名変更
    $(document).on('change blur', cls._tabName, function() {
      var $this = $(this);
      var val = $this.val().replace(/\s/g, '');

      var tabParts = cls._getTabParts($this);
      var idx = tabParts.$tgt.index($this.closest(cls._tabTgt));
      var $trg = tabParts.$trg.eq(idx);

      if (val === '') {
        $trg.addClass('is-default')
        $trg.find('button span').text(cls._tabNameDefault);
      } else {
        $trg.removeClass('is-default')
        $trg.find('button span').text(val);
      }
    });

    // タブドラッグ＆ドロップ
    $(cls._tabTrgCtnr).each(function(index, el) {
      cls._tabSortable($(el));
    });
  }

  // イベント発火した要素に関連するタブパーツを取得して返却
  _getTabParts($child) {
    var cls = this;

    var retObj = {};
    var $prt = $child.closest(cls._tabPrt);

    retObj.$prt = $prt;
    retObj.$trg = $prt.find(cls._tabTrg);
    retObj.$trgCtnr = $prt.find(cls._tabTrgCtnr);
    retObj.$tgt = $prt.find(cls._tabTgt);
    retObj.$tgtCtnr = $prt.find(cls._tabTgtCtnr);

    return retObj;
  }

  _tabSortable($tgt) {
    var cls = this;

    var $self = $tgt;
    var idxBefore;
    var idxAfter;
    var tabParts;

    $self.sortable({
      cancel: cls._tabAdd,
      start: function(e, ui) {
        tabParts = cls._getTabParts(ui.item);
        idxBefore = tabParts.$trg.index(ui.item);
      },
      stop: function(e, ui) {
        if (ui.item.is(':last-child')) {
          // 最後尾は常に「＋」ボタンになるので最後尾配置された場合は移動キャンセル
          $self.sortable('cancel');
        } else {
          // 変更後のインデックス番号を取得
          tabParts = cls._getTabParts(ui.item);
          idxAfter = tabParts.$trg.index(ui.item);

          // ※場所移動（最後尾の場合に処理されるとまずい）
          // 移動していた場合、対応するコンテンツも合わせて移動する
          if (idxBefore !== idxAfter) {
            var $moveTgt = tabParts.$tgt.eq(idxBefore).clone();
            tabParts.$tgt.eq(idxBefore).remove();

            // removeしたので要素集を一度アップデート
            tabParts = cls._getTabParts(ui.item);

            if (idxAfter - 1 < 0) {
                // 先頭への移動
                tabParts.$tgt.eq(0).before($moveTgt);
            } else {
                // 先頭以外への移動
                tabParts.$tgt.eq(idxAfter - 1).after($moveTgt);
            }

            // ■並び順を更新
            // tabパーツ
            var $tabs = $tgt.children('.c-tab_session_btn');
            for (var i = 0; i < $tabs.length; i++) {

                var $hid = $tabs.eq(i).find('.c-tab_hid_number');
                $hid.val(i + 1);
            }

            // コンテンツエリア
            var $Parts = $tgt.next().find('.c-tab_cont-multi');
            for (var i = 0; i < $Parts.length; i++) {

                var $hid = $Parts.eq(i).find('.hid_tr_number');
                $hid.val(i + 1);
                //alert($hid.val());
            }
            // ■並び順を更新
          }
        }

        // // 移動していた場合、対応するコンテンツも合わせて移動する
        // if (idxBefore !== idxAfter) {
        //   var $moveTgt = tabParts.$tgt.eq(idxBefore).clone();
        //   tabParts.$tgt.eq(idxBefore).remove();

        //   // removeしたので要素集を一度アップデート
        //   tabParts = cls._getTabParts(ui.item);

        //   if (idxAfter - 1 < 0) {
        //     // 先頭への移動
        //     tabParts.$tgt.eq(0).before($moveTgt);
        //   } else {
        //     // 先頭以外への移動
        //     tabParts.$tgt.eq(idxAfter - 1).after($moveTgt);
        //   }
        // }
      },
    });
  }

  _initSection() {
    var cls = this;

    // 見出し追加
    $(document).on('click', cls._secAddTtl, function() {
      var $tmp = cls._$tmplTitle.clone();
      var idx = $(cls._secTtl).length;

      cls._addSection($tmp, idx);

      return false;
    });

    // 時間帯追加
    $(document).on('click', cls._secAddTimeTable, function() {
      var $tmp = cls._$tmplTimeTable.clone();
      var idx = $(cls._secTimeTable).length;

      // 追加タブのドラッグ＆ドロップを有効化
      cls._tabSortable($tmp.find(cls._tabTrgCtnr));

      cls._addSection($tmp, idx);

      return false;
    });

    // 時間帯・見出し削除
    $(document).on('change', cls._secDelTimeTable + ',' + cls._secDelTtl, function() {
      var $this = $(this);
      var $tgt;

      if ($this.is(cls._secDelTimeTable)) {
        $tgt = $this.closest(cls._secTimeTable).find('.c-ttl_h3_1');
      }
      if ($this.is(cls._secDelTtl)) {
        $tgt = $this.closest(cls._secTtl).find('.c-ttl_h3_1');
      }

      if ($this.prop('checked')) {
        $tgt.addClass('is-del');
      } else {
        $tgt.removeClass('is-del');
      }
      return false;
    });

    // 講師情報追加
    $(document).on('click', cls._secAddInstructor, function() {
      var $tmp = cls._$tmplInstructor.clone();
      var $addArea = $(this).closest(cls._tabTgt).find(cls._secAddInstructorArea);
      $tmp.appendTo($addArea).fadeIn();

      return false;
    });
  }

  _addSection($tmp, idx) {
    var cls =  this;

    // 連番を降って画面に追加
    $tmp.find('.c-ttl_h3_1 h3').append(idx + 1);
    $tmp.insertBefore(cls._$secAddArea).fadeIn();
  }
}